const inspectionApplications = [
    {
        "uuid": "1",
        "appNo": "A21080203",
        "appType": "initial",
        "phase": "inspection",
        "customerNo": "0001",
        "customerName": "源天然股份有限公司",
        "assessmentPlace": "台東廠",
        "productList": [
            {
                "productName": "杏仁玄米餅",
                "tseYueLevel": "doubleClean",
                "leezenLevel": "organic",
                "productType": "general",
                "productionLineDescription": "餅乾線",
                "processStatus": "backEnd",
                "backEndProductName": "",
                "firstPassDate": "2019-10-05T08:20:10.000Z",
                "productStatus": "improvement",
            },
            {
                "productName": "桂圓四物飲",
                "tseYueLevel": "",
                "leezenLevel": "organic",
                "productType": "general",
                "productionLineDescription": "果汁線",
                "processStatus": "backEnd",
                "backEndProductName": "",
                "firstPassDate": "2019-10-05T08:20:10.000Z",
                "productStatus": "approve",
            },
            {
                "productName": "純在生技耶子汁",
                "tseYueLevel": "",
                "leezenLevel": "good",
                "productType": "holiday",
                "productionLineDescription": "果汁線",
                "processStatus": "backEnd",
                "backEndProductName": "",
                "firstPassDate": "2020-11-20T08:20:10.000Z",
                "productStatus": "approve",
            },
            {
                "productName": "純在蔬菜棕合果汁",
                "tseYueLevel": "doubleClean",
                "leezenLevel": "",
                "productType": "",
                "productionLineDescription": "果汁線",
                "processStatus": "all",
                "backEndProductName": "",
                "firstPassDate": "2020-11-20T08:20:10.000Z",
                "productStatus": "approve",
            },
            {
                "productName": "純在芒果棕合果汁",
                "tseYueLevel": "",
                "leezenLevel": "excellent",
                "productType": "originalImported",
                "productionLineDescription": "果汁線",
                "processStatus": "frontEnd",
                "backEndProductName": "葡萄柚蘋果綠茶",
                "firstPassDate": "2020-11-20T08:20:10.000Z",
                "productStatus": "suspend",
            },
        ],
    },
    {
        "uuid": "2",
        "appNo": "A21091121",
        "appType": "expandingFactory",
        "phase": "onsiteReview",
        "customerNo": "0002",
        "customerName": "黑松股份有限公司",
        "assessmentPlace": "屏東廠",
        "productList": [
            {
                "productName": "杏仁玄米餅",
                "tseYueLevel": "doubleClean",
                "leezenLevel": "organic",
                "productType": "general",
                "productionLineDescription": "餅乾線",
                "processStatus": "backEnd",
                "backEndProductName": "",
                "firstPassDate": "2019-10-05T08:20:10.000Z",
                "productStatus": "improvement",
            },
            {
                "productName": "桂圓四物飲",
                "tseYueLevel": "",
                "leezenLevel": "organic",
                "productType": "general",
                "productionLineDescription": "果汁線",
                "processStatus": "backEnd",
                "backEndProductName": "",
                "firstPassDate": "2019-10-05T08:20:10.000Z",
                "productStatus": "approve",
            },
            {
                "productName": "純在生技耶子汁",
                "tseYueLevel": "",
                "leezenLevel": "good",
                "productType": "holiday",
                "productionLineDescription": "果汁線",
                "processStatus": "backEnd",
                "backEndProductName": "",
                "firstPassDate": "2020-11-20T08:20:10.000Z",
                "productStatus": "approve",
            },
            {
                "productName": "純在蔬菜棕合果汁",
                "tseYueLevel": "doubleClean",
                "leezenLevel": "",
                "productType": "",
                "productionLineDescription": "果汁線",
                "processStatus": "all",
                "backEndProductName": "",
                "firstPassDate": "2020-11-20T08:20:10.000Z",
                "productStatus": "approve",
            },
            {
                "productName": "純在芒果棕合果汁",
                "tseYueLevel": "",
                "leezenLevel": "excellent",
                "productType": "originalImported",
                "productionLineDescription": "果汁線",
                "processStatus": "frontEnd",
                "backEndProductName": "葡萄柚蘋果綠茶",
                "firstPassDate": "2020-11-20T08:20:10.000Z",
                "productStatus": "suspend",
            },
        ],
    },
    {
        "uuid": "3",
        "appNo": "A21092003",
        "appType": "followUp",
        "phase": "assessmentDecision",
        "customerNo": "0003",
        "customerName": "中農粉絲有限公司",
        "assessmentPlace": "桃園廠",
        "productList": [
            {
                "productName": "杏仁玄米餅",
                "tseYueLevel": "doubleClean",
                "leezenLevel": "organic",
                "productType": "general",
                "productionLineDescription": "餅乾線",
                "processStatus": "backEnd",
                "backEndProductName": "",
                "firstPassDate": "2019-10-05T08:20:10.000Z",
                "productStatus": "improvement",
            },
            {
                "productName": "桂圓四物飲",
                "tseYueLevel": "",
                "leezenLevel": "organic",
                "productType": "general",
                "productionLineDescription": "果汁線",
                "processStatus": "backEnd",
                "backEndProductName": "",
                "firstPassDate": "2019-10-05T08:20:10.000Z",
                "productStatus": "approve",
            },
            {
                "productName": "純在生技耶子汁",
                "tseYueLevel": "",
                "leezenLevel": "good",
                "productType": "holiday",
                "productionLineDescription": "果汁線",
                "processStatus": "backEnd",
                "backEndProductName": "",
                "firstPassDate": "2020-11-20T08:20:10.000Z",
                "productStatus": "approve",
            },
            {
                "productName": "純在蔬菜棕合果汁",
                "tseYueLevel": "doubleClean",
                "leezenLevel": "",
                "productType": "",
                "productionLineDescription": "果汁線",
                "processStatus": "all",
                "backEndProductName": "",
                "firstPassDate": "2020-11-20T08:20:10.000Z",
                "productStatus": "approve",
            },
            {
                "productName": "純在芒果棕合果汁",
                "tseYueLevel": "",
                "leezenLevel": "excellent",
                "productType": "originalImported",
                "productionLineDescription": "果汁線",
                "processStatus": "frontEnd",
                "backEndProductName": "葡萄柚蘋果綠茶",
                "firstPassDate": "2020-11-20T08:20:10.000Z",
                "productStatus": "suspend",
            },
        ],
    },
]

export default inspectionApplications;